import "./ManualTagDialog.less"
import { inject, observer } from "mobx-react";
import { CloseBtn } from "../CloseBtn/CloseBtn";
import { useState, useRef, useEffect } from "react";
import { Input } from "antd";
import Images from "../../utils/Images";
import CustomButton from "../CustomButton/CustomButton";
import getStoreFromProps from "../../store/getStoreFromProps";
import { ColorImg } from "../ColorImg/ColorImg";

type ManualTagDialogProps = {
    startIndex: number;
    onClose: () => void;
};

export const ManualTagDialog = inject("dataset")(observer((props: ManualTagDialogProps): React.ReactElement => {
    const datasetStore = getStoreFromProps(props, "dataset");
    const [index, setIndex] = useState(props.startIndex);
    const [bottomPrompt, setBottomPrompt] = useState(""); // 所有图片标注
    const [isBottomNavBtnVisible, setIsBottomNavBtnVisible] = useState(true); // 底部左右选择按钮是否可见
    const scrollDivRef = useRef<HTMLDivElement>(null);

    const onCloseClick = (): void => {
        props.onClose();
    };

    const onWheel = (e: React.WheelEvent<HTMLDivElement>): void => {
        scrollDivRef.current!.scrollLeft -= e.deltaY;
    }

    const onImgClick = (e: React.MouseEvent<HTMLDivElement>, index: number): void => {
        setIndex(index);
    };

    const onImgPromptChange = (a: string, index: number): void => {
        datasetStore.setImgText(index, a);
    };

    const scrollImg = (a: number): void => {
        scrollDivRef.current!.children[a]?.scrollIntoView({behavior:"smooth", inline:"nearest"});
    };

    const onPrevClick = (): void => {
        setIndex(Math.max(0, index - 1));
        scrollImg(index - 1);
    };

    const onNextClick = (): void => {
        setIndex(Math.min(datasetStore.curDatasetInfo!.imgs.length - 1, index + 1));
        scrollImg(index + 1);
    };

    const onAddToHeadClick = (): void => {
        if(bottomPrompt.length <= 0){
            return;
        }
        datasetStore.addToHead(bottomPrompt);
    };

    const onAddToTailClick = (): void => {
        if(bottomPrompt.length <= 0){
            return;
        }
        datasetStore.addToTail(bottomPrompt);
    };

    const init = (): void => {
        setIsBottomNavBtnVisible(scrollDivRef.current!.scrollWidth > scrollDivRef.current!.clientWidth);
    };

    useEffect(init, []);

    const curDataset = datasetStore.curDatasetInfo!;
    return <div className="fullscreen-mask fullscreen-dialog-bg-color">
        <div className="manual-tag-dialog">
            <CloseBtn width="0.2rem" height="0.2rem" onClick={onCloseClick}></CloseBtn>
            <div className="manual-tag-dialog-title">
                <span>手动打标</span>
                <span>{`${index + 1}/${curDataset.imgs.length}`}</span>
            </div>
            <div className="manual-tag-dialog-left">
                <div className="manual-tag-dialog-left-top">
                    <div className="manual-tag-dialog-prev-btn" style={{"--img": `url(${Images.expand})`} as React.CSSProperties} onClick={onPrevClick}></div>
                    <div className="manual-tag-dialog-cur-img" style={{"--img": `url(${curDataset.imgs[index].url})`} as React.CSSProperties}></div>
                    <div className="manual-tag-dialog-next-btn" style={{"--img": `url(${Images.expand})`} as React.CSSProperties} onClick={onNextClick}></div>
                </div>
                <div className="manual-tag-dialog-left-bottom">
                    {isBottomNavBtnVisible && <div className="manual-tag-dialog-prev-btn-1" onClick={onPrevClick}>
                        <ColorImg src={Images.expand}></ColorImg>
                    </div>}
                    <div className="manual-tag-dialog-left-bottom-img-wrap no-scrollbar" onWheel={onWheel} ref={scrollDivRef}>
                        {curDataset.imgs.map((item, i) =>
                            <div key={i} data-select={index === i} className="manual-tag-dialog-left-bottom-img" style={{"--img": `url(${item.url})`} as React.CSSProperties} onClick={e => onImgClick(e, i)}></div>)}
                    </div>
                    {isBottomNavBtnVisible && <div className="manual-tag-dialog-next-btn-1" onClick={onNextClick}>
                        <ColorImg src={Images.expand}></ColorImg>
                    </div>}
                </div>
            </div>
            <div className="manual-tag-dialog-right">
                <div>为当前图片添加标注</div>
                <Input.TextArea className="manual-tag-dialog-input" variant="borderless" style={{resize:"none"}} value={curDataset.imgs[index].text} onChange={e => onImgPromptChange(e.target.value, index)} placeholder="请输入内容"></Input.TextArea>
                <div>为所有图片添加标注</div>
                <Input.TextArea className="manual-tag-dialog-input" variant="borderless" style={{resize:"none"}} value={bottomPrompt} onChange={e => setBottomPrompt(e.target.value)} placeholder="可输入打标内容"></Input.TextArea>
                <div className="manual-tag-dialog-right-bottom-btn-wrap">
                    <CustomButton className="manual-tag-dialog-right-bottom-btn" onClick={onAddToHeadClick}>添加到行首</CustomButton>
                    <CustomButton className="manual-tag-dialog-right-bottom-btn" onClick={onAddToTailClick}>添加到行尾</CustomButton>
                </div>
            </div>
        </div>
    </div>;
}));